import { ForwardRefExoticComponent } from 'react';

import WrapperMockComponent from '@hh.ru/magritte-ui-icon/WrapperMockComponent';
import { mockComponent } from '@hh.ru/magritte-ui-mock-component';

export { type IconColor, type IconDisabledColor } from '@hh.ru/magritte-ui-icon/types';

export const IconDynamic: ForwardRefExoticComponent<Record<string, unknown>> = mockComponent('IconDynamic', undefined, {
    withChildren: true,
});
export const CheckboxCheckSize16 = mockComponent(
    'CheckboxCheckSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckboxCheckSize24 = mockComponent(
    'CheckboxCheckSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckboxLineSize16 = mockComponent(
    'CheckboxLineSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckboxLineSize24 = mockComponent(
    'CheckboxLineSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const Diagram100Size16 = mockComponent(
    'Diagram100Size16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const Diagram100Size24 = mockComponent(
    'Diagram100Size24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const Diagram60Size16 = mockComponent(
    'Diagram60Size16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const Diagram60Size24 = mockComponent(
    'Diagram60Size24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const Diagram75Size16 = mockComponent(
    'Diagram75Size16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const Diagram75Size24 = mockComponent(
    'Diagram75Size24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const Diagram80Size16 = mockComponent(
    'Diagram80Size16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const Diagram80Size24 = mockComponent(
    'Diagram80Size24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GripSize16 = mockComponent(
    'GripSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GripSize24 = mockComponent(
    'GripSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MetroLineSize16 = mockComponent(
    'MetroLineSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MetroLineSize24 = mockComponent(
    'MetroLineSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MetroStationSize16 = mockComponent(
    'MetroStationSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MetroStationSize24 = mockComponent(
    'MetroStationSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RadioCircleSize16 = mockComponent(
    'RadioCircleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RadioCircleSize24 = mockComponent(
    'RadioCircleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkillPieAdvancedSize16 = mockComponent(
    'SkillPieAdvancedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkillPieAdvancedSize24 = mockComponent(
    'SkillPieAdvancedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkillPieBaseSize16 = mockComponent(
    'SkillPieBaseSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkillPieBaseSize24 = mockComponent(
    'SkillPieBaseSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkillPieMiddleSize16 = mockComponent(
    'SkillPieMiddleSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SkillPieMiddleSize24 = mockComponent(
    'SkillPieMiddleSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);
